import HttpClient from './http-clients/portaljad'

const baseUrl = 'tarifas'

export default class TarifaService {
  static async findAll() {
    try {
      const { data } = await HttpClient.get(baseUrl)
      return data.body
    } catch (error) {
      throw error.response.data
    }
  }

  static async findById(tarifaId) {
    try {
      const { data } = await HttpClient.get([baseUrl, tarifaId].join('/'))
      return data.body
    } catch (error) {
      throw error.response.data
    }
  }

  static async uploadMultipart(multipartForm) {
    try {
      const { data } = await HttpClient.post([baseUrl, 'with-sheet'].join('/'), multipartForm, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      return data
    } catch (error) {
      throw error.response.data
    }
  }

  static async edit(tarifaId, tarifa) {
    try {
      const { data } = await HttpClient.put([baseUrl, tarifaId].join('/'), tarifa)
      return data.body
    } catch (error) {
      throw error.response.data
    }
  }

  static async deleteById(tarifaId) {
    try {
      await HttpClient.delete([baseUrl, tarifaId].join('/'))
      return true
    } catch (error) {
      throw error.response.data
    }
  }
}